import * as data from './data';
import * as enums from './enum';
import * as route from './route';
import * as localStorage from './localStorage';
import * as component from './component';

export default defineNuxtPlugin(nuxtApp => {
  return {
    provide: {
      constants: {
        ...data,
        ...enums,
        ...route,
        ...localStorage,
        ...component,
      }
    }
  }
});
